import {HemisphereLight} from '../HemisphereLight';
import {ColorInterpolation} from '../../../classes/ColorInterpolation';
import {CommonScenario} from './CommonScenario';

declare const THREE: any;

export class Urban extends CommonScenario {

  protected createHemisphereLight(): HemisphereLight {
    return new HemisphereLight(
      new ColorInterpolation(
        new THREE.Color(0xf1fcff),
        new THREE.Color(.6, .6, .6)
      ),
      new ColorInterpolation(
        new THREE.Color(0x506f4e),
        new THREE.Color(.1, .1, .1)
      ),
      1
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/Urban.ts